export default "__VITE_ASSET__DHhknYg9__"